import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { ESCALATION_REASONS } from "../../../../zendeskIntegration/contants";
import PrimaryButton, {
  PrimaryButtonType,
} from "../../../common/PrimaryButton";
import TextArea from "../../../forms/textarea/TextArea";
import styles from "./escalationForm.module.scss";
interface IEscalationForm {
  error?: string;
  onEscalate: any;
  reasonsRequired: boolean;
}
export const EscalationForm = (props: IEscalationForm) => {
  const { onEscalate, reasonsRequired } = props;
  const [checked, setChecked] = React.useState([ESCALATION_REASONS.at(0)?.key]);
  const [additionalReasons, setAdditionalReasons] = useState<string>();
  const { t } = useTranslation();
  const CHARACTER_LIMIT = 200;

  const toggleCheck = useCallback(
    (key: string, isChecked: boolean) => {
      if (isChecked === true) setChecked([...checked, key]);
      else
        setChecked(
          checked.filter((item) => {
            return item !== key;
          })
        );
    },
    [checked]
  );
  const onClick = useCallback(() => {
    if (checked.length >= 1) {
      onEscalate(checked, additionalReasons);
    }
  }, [additionalReasons, checked, onEscalate]);

  const renderList = useCallback(() => {
    return ESCALATION_REASONS.map((reason, index) => {
      return (
        <div className={styles.checklist_container} key={index}>
          <FormControlLabel
            className={styles.checkBoxLabel}
            control={
              <Checkbox
                key={reason.key}
                checked={
                  checked.filter((item) => {
                    return item === reason.key;
                  }).length > 0
                }
                onChange={(event) => {
                  toggleCheck(reason.key, event.target.checked);
                }}
              />
            }
            label={<p className={styles["p1"]}>{t(reason.value)}</p>}
          />
        </div>
      );
    });
  }, [checked, t, toggleCheck]);

  return (
    <div dir="rtl">
      {reasonsRequired && (
        <>
          <br />
          {renderList()}
          <br />
          <div className={styles.additionalReasons}>
            {t("lbl_fill_escalation_problems_another_reasons")}
          </div>
          <br />
        </>
      )}
      <TextArea
        label={t("lbl_write_reasons")}
        maxCharacters={CHARACTER_LIMIT}
        height={"177.91px"}
        handleChange={(event) => {
          setAdditionalReasons(event.target.value);
        }}
      />
      <br />
      <div>
        <PrimaryButton
          id={`contract_details_escalate_confirm`}
          buttonType={PrimaryButtonType.DANGER}
          onClick={onClick}>
          {t("lbl_escalate_to_waffy")}
        </PrimaryButton>
      </div>
    </div>
  );
};
